import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { addJob, updateJob } from '../features/jobs/jobsSlice'
import { useNavigate } from 'react-router-dom'

export default function Form({ mode, job }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [title, setTitle] = useState("")
    const [type, setType] = useState("")
    const [salary, setSalary] = useState("")
    const [deadline, setdeadline] = useState("")
    const [jobId, setJobId] = useState("")

    useEffect(() => {
        if (job) {
            const { title, type, salary, deadline, id } = job || {}
            setTitle(title)
            setType(type)
            setSalary(salary)
            setdeadline(deadline)
            setJobId(id)
        }
    }, [job])

    function editJobInfo(e) {
        e.preventDefault();
        console.log("edit")
        dispatch(updateJob({
            title, type, salary, deadline, id: jobId
        }))
        navigate("/")
    }

    function addNewJob(e) {
        e.preventDefault();
        console.log("add")
        dispatch(addJob({
            title, type, salary, deadline
        }))
        navigate("/")
    }

    return (
        <form onSubmit={mode === "edit" ? editJobInfo : addNewJob} className="space-y-6">
            <div className="fieldContainer">
                <label htmlFor="lws-JobTitle" className="text-sm font-medium text-slate-300">Job Title</label>
                <select id="lws-JobTitle" name="lwsJobTitle" value={title} onChange={e => setTitle(e.target.value)} required>
                    <option value="" hidden selected>Select Job</option>
                    <option value="Software Engineer">Software Engineer</option>
                    <option value="Software Developer">Software Developer</option>
                    <option value="Full Stack Developer">Full Stack Developer</option>
                    <option value="MERN Stack Developer">MERN Stack Developer</option>
                    <option value="DevOps Engineer">DevOps Engineer</option>
                    <option value="QA Engineer">QA Engineer</option>
                    <option value="Product Manager">Product Manager</option>
                    <option value="Social Media Manager">Social Media Manager</option>
                    <option value="Senior Executive">Senior Executive</option>
                    <option value="Junior Executive">Junior Executive</option>
                    <option value="Android App Developer">Android App Developer</option>
                    <option value="IOS App Developer">IOS App Developer</option>
                    <option value="Frontend Developer">Frontend Developer</option>
                    <option value="Frontend Engineer">Frontend Engineer</option>
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobType">Job Type</label>
                <select id="lws-JobType" name="lwsJobType" required value={type} onChange={e => setType(e.target.value)}>
                    <option value="" hidden selected>Select Job Type</option>
                    <option value="Full Time">Full Time</option>
                    <option value="Internship">Internship</option>
                    <option value="Remote">Remote</option>
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobSalary">Salary</label>
                <div className="flex border rounded-md shadow-sm border-slate-600">
                    <span className="input-tag">BDT</span>
                    <input type="number" name="lwsJobSalary" min="0" id="lws-JobSalary" value={salary} onChange={e => setSalary(e.target.value)} required className="!rounded-l-none !border-0"
                        placeholder="20,00,000" />
                </div>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobDeadline">Deadline</label>
                <input type="date" name="lwsJobDeadline" id="lws-JobDeadline" value={deadline} onChange={e => setdeadline(e.target.value)} required />
            </div>

            <div className="text-right">
                <button type="submit" id="lws-submit" className="cursor-pointer btn btn-primary w-fit">
                    {mode === "add" ? "Submit" : "Update"}
                </button>
            </div>
        </form>
    )
}
